import React, { PureComponent, ReactNode } from 'react';
import { reject, whereEq } from 'ramda';
import random from '@wavevision/ts-utils/strings/random';

import Flash from '../../../../Components/FlashMessage/assets';
import {
  FLASH_ERROR,
  FLASH_SUCCESS,
  FLASH_WARNING,
} from '../../../../Components/FlashMessage/assets/scripts/constants';
import {
  DeleteFlashMessage,
  FlashMessage,
  FlashMessageAssembled,
  FlashMessageType,
  FlashMessageWithType,
} from '../../../../Components/FlashMessage/assets/scripts/types';

import { FlashMessagesState } from './types';

class FlashMessages extends PureComponent<
  Record<string, never>,
  FlashMessagesState
> {
  public readonly state: FlashMessagesState = { flashMessages: [] };

  // eslint-disable-next-line react/sort-comp
  private readonly createTypeHandler =
    (type: FlashMessageType) =>
    (props: FlashMessage): FlashMessageAssembled =>
      this.showFlashMessage({ ...props, type });

  private readonly deleteFlashMessage: DeleteFlashMessage = id => {
    const flashMessages = reject(whereEq({ id }))(this.state.flashMessages);
    if (flashMessages !== this.state.flashMessages) {
      this.setState({ flashMessages });
    }
  };

  public readonly showError = this.createTypeHandler(FLASH_ERROR);

  public readonly showSuccess = this.createTypeHandler(FLASH_SUCCESS);

  public readonly showWarning = this.createTypeHandler(FLASH_WARNING);

  public readonly showFlashMessage = (
    props: FlashMessageWithType,
  ): FlashMessageAssembled => {
    const id = `flash-${random()}`;
    const flash = {
      ...props,
      id,
    };
    this.setState(state => ({
      flashMessages: [...state.flashMessages, flash],
    }));
    return flash;
  };

  public componentDidMount(): void {
    if (!window.FlashMessage) {
      window.FlashMessage = {
        showError: this.showError,
        showFlashMessage: this.showFlashMessage,
        showSuccess: this.showSuccess,
        showWarning: this.showWarning,
      };
    }
  }

  public render(): ReactNode {
    return (
      <>
        {this.state.flashMessages.map(flash => (
          <Flash {...flash} delete={this.deleteFlashMessage} key={flash.id} />
        ))}
      </>
    );
  }
}

export default FlashMessages;
